import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as spilledSubstancesServiceClear } from './spilledSubstancesService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'spilledSubstances',
  serviceTableName: 'spilledSubstancesService',
  serviceClearFunction: spilledSubstancesServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.spilledSubstance]),
});
